import React from 'react';
import { useUpdateShape } from 'hooks';
import Collapse from './Collapse';
import EventFields from './EventFields';

export const EventStyle = ({ object, toolbarRef }) => {
  const onChange = useUpdateShape(object.id);
  return (
    <Collapse text="Event">
      <EventFields shape={object} onChange={onChange} toolbarRef={toolbarRef} />
    </Collapse>
  );
};

export default EventStyle;
